import React, {useCallback, useEffect, useState} from "react";
import {HeaderComponent} from "../../components/common/header/HeaderComponent";
import {ButtonComponent} from "../../components/common/button/ButtonComponent";
import {useNavigate, useParams} from "react-router-dom";
import {RouteParam} from "../../types/types";
import {StaticCardComponent} from "../../components/common/static-card/StaticCardComponent";
import './Start.scss'
import {useThemeSelector} from "../../hooks/theme/useThemeSelector";
import {LottiePlayerComponent} from "../../components/common/lottie-player/LottiePlayerComponent";
import * as landing from "../../assets/lotties/Emerge_Lottie_ID_Landing_Launch.json";
import {LogoComponent} from "../../components/common/logo/LogoComponent";
import {ExternalLinkComponent} from "../../components/common/external-link/ExternalLinkComponent";
import {ReactComponent as TakeSelfieIcon} from '../../assets/icons/no-id.svg';
import {ReactComponent as IdentificationIcon} from '../../assets/icons/identification.svg';
import {useThemedCopy} from "../../components/common/theme-provider/hooks/useThemedCopy";

export const StartPage: React.FC = () => {

    const { verificationId } = useParams<RouteParam>();
    const navigate = useNavigate()
    const { theme } = useThemeSelector()
    const [start, setStart] = useState(false)
    const [fqaLink, setFaqLink] = useState("")
    const { copy } = useThemedCopy()

    const setTimeoutInterval = useCallback(() => {
        if  (theme === 'emerge') {
            return 9500
        } else {
            return 1500
        }
    }, [theme])

    useEffect(() => {
        const time = setTimeoutInterval()
        if (theme !== 'default') {
            if (theme === "emerge") {
                setFaqLink("https://intercom.help/emerge/en/articles/8719659-aml-faq")
            } else if (theme === "squareone") {
                setFaqLink("https://intercom.help/emerge/en/articles/8719659-aml-faq")
            }
            setStart(false)
            setTimeout(() => {
                setStart(true)
            }, time)
        } else {
            setStart(true)
        }
    }, [setTimeoutInterval, theme]);

    const navigateToDataConsent = () => {
        navigate(`/${verificationId}/document`)
    }

    const isMobileDevice = () => {
        return window.innerWidth < 500
    }

    const showLandingPage = () => {
        if (theme === 'emerge') {
            return <div className={`landing-lottie`}><LottiePlayerComponent animationData={landing}/></div>
        } else {
            return <span className={`landing-icon`}><LogoComponent/></span>
        }
    }

    return start || isMobileDevice() ? (
        <div className={`background background-white general-container information-container height-window`}>
            <HeaderComponent title={copy.start.header.title} subtitle={copy.start.header.subtitle}/>

            <div className={`start-card-container`}>
                <div className={`font-lg primary-color`}>
                    What you'll need to do:
                </div>
                <StaticCardComponent
                    title={copy.start.id.header}
                    text={copy.start.id.text}
                    gradient
                    icon=<IdentificationIcon/>
                />
                <StaticCardComponent
                    title={copy.start.selfie.header}
                    text={copy.start.selfie.text}
                    secondaryGradient
                    icon=<TakeSelfieIcon/>
                />
                <ExternalLinkComponent
                    text="Why we need this information"
                    url={fqaLink}
                />
            </div>
            <div className={`information-container-button start-button width-full`}>
                <ButtonComponent label="Get started" onButtonClick={() => navigateToDataConsent()} />
            </div>
        </div>
    ) : (
        <div className={`app-background flex-center`}>
            <div className={`flex-center`}>
                {showLandingPage()}
            </div>
        </div>
    )
}